import { Component } from "@angular/core";
import { ActivatedRoute, Router, ActivatedRouteSnapshot, UrlSegment, NavigationEnd } from "@angular/router";
import { AppSettings } from "../../app.settings";
import { Settings } from "../../app.settings.model";
import { MenuService } from "../../theme/components/menu/menu.service";

@Component({
    selector: "app-breadcrumb",
    templateUrl: "./breadcrumb.component.html",
    styleUrls: ["./breadcrumb.component.scss"],
    providers: [MenuService]
})
export class BreadcrumbComponent
{

    public breadcrumbs: {
        name: string;
        url: string
    }[] = [];

    public settings: Settings;
    constructor(public appSettings: AppSettings,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        private menuService: MenuService)
    {
        this.settings = this.appSettings.settings;
        this.router.events.subscribe(event =>
        {
            if (event instanceof NavigationEnd)
            {
                this.breadcrumbs = [];
                this.parseRoute(this.router.routerState.snapshot.root);
            }
        });
    }

    private parseRoute(node: ActivatedRouteSnapshot)
    {
        if (node.data.breadcrumb)
        {
            if (node.url.length)
            {
                let urlSegments: UrlSegment[] = [];
                node.pathFromRoot.forEach(routerState =>
                {
                    urlSegments = urlSegments.concat(routerState.url);
                });
                const url = urlSegments.map(urlSegment =>
                {
                    return urlSegment.path;
                }).join("/");
                this.breadcrumbs.push({
                    name: node.data.breadcrumb,
                    url: "/" + url
                });
            }
        }
        if (node.firstChild)
        {
            this.parseRoute(node.firstChild);
        }
    }

    public closeSubMenus()
    {
        if (this.settings.menu === "vertical")
        {
            this.menuService.closeAllSubMenus();
        }
    }
}
